import { useContext } from 'react';

import { UniqueKeyContext } from './UniqueKeyProvider';

export const useUniqueKey = (): UniqueKeyContext => {
	return useContext(UniqueKeyContext);
};
